import addStartupScript from '../events/addStartupScript';
import addTargetEventListener from '../events/addTargetEventListener';
import forEachSelector from '../elements/forEachSelector';
import { selectors } from './elements/constants';
import * as navigationModel from './models/navigation';
import * as validationModel from './models/validation';
import * as eventsModel from './models/events';
import isEmpty from 'lodash/isEmpty';
import getCookieOrMeta from '../storage/getCookieOrMeta';

export function setup() {
  forEachSelector(selectors.form, form => {
    const panel = form.querySelector(selectors.activePanel);
    navigationModel.cancelFallbackOnclickActions(form);

    if (panel) {
      eventsModel.dispatchShowStepEvent(panel, { direction: 'forward' });
    }
  });
  checkMetaTags();
}

export function checkMetaTags() {
  const missingMetaTags = getMissingMetaTags();
  if (!isEmpty(missingMetaTags)) {
    if (process.env.NODE_ENV !== 'production') {
      console.warn(`Missing meta tags: ${missingMetaTags.join(', ')}`);
    }
    if (window.newrelic) {
      window.newrelic.noticeError(`Missing meta tags: ${missingMetaTags.join(', ')}`, { 'customAttributes': { 'tags': missingMetaTags } });
    }
  }
}

const getMissingMetaTags = () => (
  ['referer', 'landing_page', 'visitor-id'].filter((name) => !getCookieOrMeta(name))
);

addStartupScript(setup);

// form-wizard events
addTargetEventListener(eventsModel.events.navigate, selectors.wrapper, navigationModel.navigate);
window.addEventListener('popstate', navigationModel.popState);

// other DOM events
const activeNextButton = [selectors.form, selectors.active, selectors.nextButton].join(' ');
const activeBackButton = [selectors.form, selectors.active, selectors.backButton].join(' ');
addTargetEventListener('click', activeNextButton, navigationModel.navigateForwards);
addTargetEventListener('click', activeBackButton, navigationModel.navigateBackwards);

// TODO: use form-wizard eventing to handle validation and submission for manual forms and scheduler
// revalidate form without having to progress or submit the form
addTargetEventListener('keyup', selectors.form, validationModel.revalidate);
addTargetEventListener('change', selectors.form, validationModel.revalidate);
